import { About as AboutContainer } from '@containers';

const About = () => {
  return <AboutContainer />;
};

export default About;
